export default `<style >
table.notice-confirm-js,table.notice-confirm-js td{
    border: 1px solid #000;
    border-collapse: collapse;
}
</style>
<p style="margin-bottom:24px;text-align:center;line-height:29px">
    <strong><span style="font-size:21px; ;color:black;letter-spacing:1px">保险经纪服务授权委托书</span></strong>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">&nbsp;</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">一、甲方委托乙方作为保险经纪人提供保险经纪服务。 </span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">二、乙方已将公司名称、营业场所、业务范围、联系方式等基本事项告知甲方，甲方知晓告知书内容并同意委托乙方为保险经纪人，代表或协助甲方处理保险相关事宜。</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">三、甲方委托及服务具体事项为：拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为甲方提供防灾、防损或风险评估、风险管理咨询服务、中国银保监会批准的其他业务，以及甲方委托乙方处理的符合法律法规、监管规定的其他事项。</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">四、基于为甲方提供保险期内服务的需要，乙方有权从保险公司处获取与甲方的保险合同有关的信息和数据。</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">五、甲方同意并协助乙方与保险人协商，依法从保险人处取得与甲方保险合同相关的佣金作为报酬。</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">六、本协议有效期自双方签章之日起生效，至甲方已无《保险经纪服务授权委托书》涉及的委托事项产生。</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; ">七、本协议未尽事宜，双方可另行协商确定。</span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; "><br/></span>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; "></span>
</p>
<p style="text-align:center;line-height:24px">
    <strong><span style="font-size:20px;">客户告知书</span></strong>
</p>
<p style="line-height:17px">
    <span style="font-size:13px; ">尊敬的客户：</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">&nbsp;</span><span style="font-size: 13px; ">感谢您通过易才宏业保险经纪有限公司办理保险业务。本公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了您的合法权益得到有效保护，按照《保险经纪人监管规定》要求，本公司履行客户告知义务，现将有关事项告知如下，请您认真阅读确认知悉以下内容：</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <strong><span style="font-size: 13px; ">一、公司基本情况</span></strong>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（一）公司名称：易才宏业保险经纪有限公司 </span>
</p>
<p style="text-indent:26px;line-height:17px">
    <span style="font-size:13px; ">（二）经营场所：</span>
</p>
<p style="text-indent:26px;line-height:17px">
    <span style="font-size:13px; ">&nbsp;</span>
</p>
<table style="margin: 0 auto" width="643" class="notice-confirm-js">
    <tbody>
        <tr style=";height:19px" class="firstRow">
            <td width="65" style="padding: 0px 7px;">
                <p>
                    <strong><span style="font-size:12px; ">机构类别</span></strong>
                </p>
            </td>
            <td width="246" style="padding: 0px 7px;">
                <p style="text-align:center">
                    <strong><span style="font-size:12px; ">名称</span></strong>
                </p>
            </td>
            <td width="321" style="padding: 0px 7px;">
                <p style="text-align:center">
                    <strong><span style="font-size: 12px; ">住所</span></strong>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">总公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司北京分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">北京市朝阳区广渠东路唐家村43幢一层28-B</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司陕西分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">陕西省西安市雁塔区融鑫路1号203室</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司新疆分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">新疆乌鲁木齐市天山区光明路100号金碧华府1503室</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司甘肃分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">甘肃省兰州市城关区闵家桥100号一楼049室</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司河北分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">河北省石家庄市桥西区新石南路6号汇龙国际公馆小区1-1401室</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司沧州分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">河北省沧州高新区河北工业大学科技园4号楼2层209号房间</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司吉林分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">长春市二道区东盛大街与荣光路交汇力旺·东玺台写字楼15栋703室</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司广西分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">南宁市青秀区仙葫开发区仙葫大道西241、243号</span>
                </p>
            </td>
        </tr>
        <tr style=";height:19px">
            <td width="50" style="border-right-width: 1px; border-bottom-width: 1px; border-left-width: 1px; border-right-color: windowtext; border-bottom-color: windowtext; border-left-color: windowtext; border-top: none; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">分公司</span>
                </p>
            </td>
            <td width="246" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p style="text-align:center">
                    <span style="font-size:12px; ">易才宏业保险经纪有限公司江西分公司</span>
                </p>
            </td>
            <td width="321" style="border-top: none; border-left: none; border-bottom-width: 1px; border-bottom-color: windowtext; border-right-width: 1px; border-right-color: windowtext; padding: 0px 7px;">
                <p>
                    <span style="font-size: 12px; ">江西省赣州市南康区东山街道办事处臻顺跨境电商产业园18栋1002[住所(经营场所)自主申报]</span>
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p style="text-indent:26px;line-height:17px">
    <span style="font-size:13px; ">&nbsp;</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（三）业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国银保监会批准的其他业务。</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（四）许可证名称：经营保险经纪业务许可证</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（五）机构编码：269653000000800</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（六）经营区域：全国</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（七）公司联系方式<strong>：<span style="color:red">4006-234-345</span></strong></span>
</p>
<p style="line-height:17px">
    <span style="font-size:13px; ">&nbsp;&nbsp;&nbsp; </span><strong><span style="font-size:13px; ">二、获取报酬的方式&nbsp; </span></strong><span style="font-size:13px; ">接受投保人委托，为投保人与保险公司订立保险合同提供经纪服务，向保险人或投保人收取佣金；协助被保险人或者受益人进行索赔，向委托人收取佣金；为委托人提供防灾防损或者风险评估、风险管理咨询服务，向委托人收取咨询费；<strong>我公司收取佣金或咨询费方式均与委托人、投保人或保险人商议并通过签订书面合同进行约定。</strong></span>
</p>
<p style="text-indent:28px;line-height:17px">
    <strong><span style="font-size:13px; ">三、投保前告知 </span></strong>
</p>
<p style="text-indent:27px;line-height:17px">
    <span style="font-size:13px; ">（一）根据保险监管部门的规定，从业人员从事保险经纪业务需持有《保险经纪从业人员执业证书》，您可要求本公司业务人员出示《保险经纪从业人员执业证书》，并可通过登录中国保监会保险中介监管信息系统查询业务人员持证情况。</span>
</p>
<p style="text-indent:28px;line-height:17px">
    <span style="font-size:13px; ">（二）请仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等内容，并可要求本公司业务人员对上述内容进行详细讲解。</span>
</p>
<p style="text-indent:28px;line-height:17px">
    <span style="font-size:13px; ">（三）如果您投保的是一年期以上（不含一年期）的个人人身保险，根据保险监管部门的规定，保险公司应当向您提供由中国银保监会规定基准内容的《人身保险投保提示书》。《人身保险投保提示书》着重对投保人合法保险权益、投保注意事项等进行提示，为了保护您的合法权益，请您在投保前务必认真阅读《人身保险投保提示书》。</span>
</p>
<p style="text-indent:28px;line-height:17px">
    <span style="font-size:13px; ">（四）请向本公司业务人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。 </span>
</p>
<p style="text-indent:27px;line-height:17px">
    <strong><span style="font-size: 13px; ">四、法律责任 </span></strong><span style="font-size:13px; ">根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。本公司已按《保险经纪人监管规定》投保了职业责任保险。 </span>
</p>
<p style="text-indent:27px;line-height:17px">
    <strong><span style="font-size: 13px; ">五、关联关系</span></strong><span style="font-size:13px; "> 易才宏业保险经纪有限公司为易才宏业管理顾问有限公司100%控股子公司，阳光人寿持有易才宏业管理顾问有限公司37.17%股权并派驻董事，因此易才宏业保险经纪有限公司为阳光人寿施加重大影响的法人，构成关联关系。</span><span style="font-size:13px; ;color:#333333;background: white">我公司高级管理人员与经纪业务相关的保险公司、其他保险中介机构不存在关联关系。</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <strong><span style="font-size: 13px; ">六、投诉方式</span></strong><span style="font-size:13px; ">&nbsp; </span><span style="font-size: 13px; ">如发现我公司从业人员存在销售误导行为及其他损害您合法权益的行为，请注意保留相关证据，并拨打电话<strong><span style="color:red">4006-234-345</span>;&nbsp; </strong>我公司将根据投诉事项选择处理方式，包括但不限于正式道歉（存在服务不足时）、更换服务人员、加快案件处理时效、提升沟通频率等。</span>
</p>
<p style="text-indent:27px;line-height:17px">
    <strong><span style="font-size:13px; ">以上告知事项敬请随时查询、核实。</span></strong>
</p>
<p>
    <strong><span style="font-size:13px; ">特此告知。&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></strong>
</p>
<p style="text-indent:29px;line-height:27px">
    <span style="font-size:15px; "><br/></span><br/>
</p>
<p>
    <br/>
</p>`